module.exports = __webpack_public_path__ + "media/images/icons/calendar-de61ae5dfce3919bffcedbe5098cc128.svg";